<template>
  <v-card
    flat
    :disabled="Object.keys(validationResult).length === 0"
  >
    <v-tabs v-model="tabIndex" >
      <v-tab
          v-for="(item, index) in tabItems"
          :key="index"
          :href="'#' + item.href"
          exact
          active-class="primary--text"
          class="subheading text-capitalize tab-item"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <v-divider class="mb-5"/>
    <div :class="[$style.scrollable]">
      <v-tabs-items v-model="tabIndex">
        <v-tab-item value="tab-1">
          <error-list :errors-data="xsdErrors" />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <error-list :errors-data="schematronErrors" />
        </v-tab-item>
        <v-tab-item value="tab-3">
          <error-list :errors-data="schematronWarnings" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>
<script>
import _ from 'lodash';
import ErrorList from '@/components/NemsisExport/ErrorList';

export default {
  name: 'ValidateResults',
  components: { ErrorList },
  props: {
    validationResult: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tabIndex: 'tab-1',
    };
  },
  watch: {
    validationResult() {
      this.tabIndex = 'tab-1';
    },
  },

  computed: {
    /**
     * XSD errors by section.
     *
     * @return {Object}
     */
    xsdErrors() {
      return this.asObject(this.validationResult.xsd);
    },

    /**
     * Schematron errors by section.
     *
     * @return {Object}
     */
    schematronErrors() {
      return this.asObject((this.validationResult.schematron || {}).errors);
    },

    /**
     * Schematron warnings by section.
     *
     * @return {Object}
     */
    schematronWarnings() {
      return this.asObject((this.validationResult.schematron || {}).warnings);
    },

    /**
     * List of tab items.
     *
     * @return {Array}
     */
    tabItems() {
      return [
        { name: `XSD (${this.countErrors(this.xsdErrors)})`, href: 'tab-1' },
        { name: `Schematron Errors (${this.countErrors(this.schematronErrors)})`, href: 'tab-2' },
        { name: `Schematron Warnings (${this.countErrors(this.schematronWarnings)})`, href: 'tab-3' },
      ];
    },
  },

  methods: {
    /**
     * Section data as an object; empty JSON arrays become empty objects.
     *
     * @param {Object|Array|undefined} value - Section-keyed findings
     *
     * @return {Object}
     */
    asObject(value) {
      const data = value || {};
      return data.length === 0 ? {} : data;
    },

    /**
     * Count findings across sections.
     *
     * @return {Number}
     */
    countErrors(errorsBySections) {
      let count = 0;
      _.forEach(errorsBySections, (errors) => {
        count += errors.length;
      });
      return count;
    },
  },
};
</script>
<style lang="scss" module>
.scrollable {
  // Fills the viewport below the page header, toolbar and tabs; shrinks with the
  // window because the offset is in vh-relative calc, no JS resize handling needed.
  // The height is exposed as an inherited CSS variable so ErrorList can center its
  // "No errors" state within the same area.
  --validation-area-height: max(calc(100vh - 350px), 200px);
  height: var(--validation-area-height);
  overflow-y: auto;
}
</style>
